import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

export const Field = styled.span``;

export const FullLine = styled.div``;

export const LeftHalf = styled.div``;

export const RightHalf = styled.div``;

export const LoadingWrapper = styled.div`
	width: 100%;
	height: calc(100vh - 350px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Container = styled.div`
	display: grid;
	gap: 20px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		${FullLine} {
			grid-column: 1/3;
		}

		${LeftHalf} {
			grid-column: 1;
		}

		${RightHalf} {
			grid-column: 2;
		}

		${LoadingWrapper} {
			grid-column: 1/3;
		}
	}
`;

export const Separator = styled.hr`
	height: 1px;
	padding: 0;
	margin: 16px 0 0;
	border: none;
	width: 100%;
	background-color: #ced4da;
`;

export const SectionDashboard = styled.div`
	background-color: ${({ theme }) => theme.colors.neutral.white};
	border-radius: 12px;
	padding: 16px;
	width: 100%;
	min-height: 300px;
`;

export const SectionTitle = styled.div`
	${({ theme }) => theme.typography.headlines.h5};
`;

export const CardsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 24px;
	padding: 32px 10px;
	max-width: 1200px;
	width: 100%;

	> a {
		width: auto;
		cursor: pointer;
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns: repeat(2, 1fr);
		gap: 12px;
	}
`;
